import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
var NavigationEventsService = /** @class */ (function () {
    function NavigationEventsService() {
        this.homeRequestedSubject = new Subject();
        this.homeRequested$ = this.homeRequestedSubject.asObservable();
    }
    NavigationEventsService.prototype.requestHome = function () {
        this.homeRequestedSubject.next();
    };
    NavigationEventsService.ngInjectableDef = i0.defineInjectable({ factory: function NavigationEventsService_Factory() { return new NavigationEventsService(); }, token: NavigationEventsService, providedIn: "root" });
    return NavigationEventsService;
}());
export { NavigationEventsService };
